import React, { JSX } from 'react';
import { DndProvider } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';

const FormElementListWrapper = ({children}: {children: JSX.Element[]}) => {
    return( 
        <DndProvider backend={TouchBackend} options={{enableMouseEvents: true}}>
             <div className='form-builder-wrapper'>
                {children}
            </div>
        </DndProvider>
       
     )
}

export default FormElementListWrapper